import { styled } from "@mui/material/styles";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const CompactMarkdown = styled("div")(() => ({
  display: "inline",
  "& p": {
    display: "inline",
    margin: 0,
  },
  "& ul, & ol": {
    display: "inline",
    margin: 0,
    padding: 0,
  },
  "& li": {
    display: "inline",
  },
  "& li + li::before": {
    content: '", "',
  },
}));

type MessageMarkdownContentProps = {
  content: string;
  compact?: boolean;
};

export default function MessageMarkdownContent(props: Readonly<MessageMarkdownContentProps>) {
  const { content } = props;
  const compact = props.compact ?? false;

  const markdown = <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>;

  if (compact) {
    return <CompactMarkdown>{markdown}</CompactMarkdown>;
  }

  return markdown;
}
